import React, { useState } from "react";
import AboutView from "./AboutUs";
import BrandView from "./BrandStory";
import styles from "./AboutMain.module.css";

const AboutMain = () => {
  const [activeTab, setActiveTab] = useState("about");

  const renderContent = () => {
    switch (activeTab) {
      case "about":
        return <AboutView />;
      case "brand":
        return <BrandView />;
      default:
        return null;
    }
  };

  return (
    <div className={styles["all_container"]}>
      <div className={styles["brand_company_tab"]}>
        <h2>About Us</h2>
        <div className={styles["tabs"]}>
          <a
            className={`${styles["tab-link"]} ${
              activeTab === "about" ? styles["active"] : ""
            }`}
            onClick={() => setActiveTab("about")}
          >
            About Us
          </a>
          <a
            className={`${styles["tab-link"]} ${
              activeTab === "brand" ? styles["active"] : ""
            }`}
            onClick={() => setActiveTab("brand")}
          >
            Brand Story
          </a>
        </div>
      </div>
      <div className={styles["tab-content"]}>{renderContent()}</div>
    </div>
  );
};

export default AboutMain;
